module.exports = __webpack_public_path__ + "static/stairs_windows_night-c706aaafbf2cda431b12130b6c50a6c2.jpg";